import PageRoot from 'app/KinerjaKSPage/components/EvaluationResult/PageRoot'
import PageHeader from 'app/KinerjaKSPage/components/EvaluationResult/PageHeader'
import BannerDinas from 'app/KinerjaKSPage/components/EvaluationResult/BannerDinas'
import EvaluationResultHeader from 'app/KinerjaKSPage/components/EvaluationResult/EvaluationResultHeader'
import EvaluationResultRoot from 'app/KinerjaKSPage/components/EvaluationResult/EvaluationResultRoot'
import EvaluationResultInfo from 'app/KinerjaKSPage/components/EvaluationResult/EvaluationResultInfo'
import EvaluationResultDetails from 'app/KinerjaKSPage/components/EvaluationResult/EvaluationResultDetails'
import EvaluationResultSummary from 'app/KinerjaKSPage/components/EvaluationResult/EvaluationResultSummary'
import PageError from 'app/KinerjaKSPage/components/EvaluationResult/PageError'
import PageSpinner from 'app/KinerjaKSPage/components/EvaluationResult/PageSpinner'
import PageContent from 'app/KinerjaKSPage/components/EvaluationResult/PageContent'
import EvaluationResultContent from 'app/KinerjaKSPage/components/EvaluationResult/EvaluationResultContent'

const EvaluationResult = {
  Root: PageRoot,
  Header: PageHeader,
  Content: PageContent,
  BannerDinas: BannerDinas,
  Spinner: PageSpinner,
  Error: PageError,

  // Result
  Result: {
    Root: EvaluationResultRoot,
    Header: EvaluationResultHeader,
    Content: EvaluationResultContent,
    Info: EvaluationResultInfo,
    Details: EvaluationResultDetails,
    Summary: EvaluationResultSummary,
  },
}

export default EvaluationResult
